import { print as log } from '@/utils/consolelog'
import firebase from 'firebase/app'
import 'firebase/messaging'

const config = {
	apiKey: "AIzaSyAGiNXtvCIUL_M9A-S3GXbz-G8a1F7bJZw",
	authDomain: "idicare-sk.firebaseapp.com",
	databaseURL: "https://idicare-sk.firebaseio.com",
	projectId: "idicare-sk",
	storageBucket: "idicare-sk.appspot.com",
	messagingSenderId: "673098652056"
}

const publicVapidKey = "BPHHtfjBm8ilpHLKwXUbLxeTEo71TF_0eEG7j8DSYayRVG2qpT277_WFcjCdUfiDLZ4KuMu3r4yqm9EababZWMY"

export default {

	swRegistration: null,
	messaging: null,
	pushToken: null,
	isSubscribed: false,

	callback: null,
	context: null,

	// Register Service Worker
	register (callback, context) {

		this.context = context
		this.callback = callback

		log('info', 'main', 'service worker', 'register')()

		if (!('serviceWorker' in navigator)) {
			log('warn', 'main', 'service worker', 'not supported in this browser')()
			return
		}

		navigator.serviceWorker.register('/sw.js')
			.then(registration => {

				//console.log('Service Worker scope: ' + registration.scope)

				log('info', 'main', 'service worker', 'is registered')()

				this.swRegistration = registration

				if (navigator.serviceWorker) {
					this.requestPermission()
				}
			})
			.catch(error => {
				console.error('Service Worker error', error)
			})
	},

	// Request Push Notifications permission
	requestPermission () {
		if (!('PushManager' in window && 'Notification' in window)) {
			log('warn', 'main', 'push notifications', 'not supported in this browser')()
			return
		}

		if (!firebase.apps.length) {
			firebase.initializeApp(config)

			this.messaging = firebase.messaging()
			this.messaging.usePublicVapidKey(publicVapidKey)

			log('info', 'main', 'push notifications', 'request permission')()

			this.context.$root.$on('notification-request', () => {
				this.sendRequestPermission()
			})

			if (this.context.$store.getters.GET_NOTIFICATIONS_ALLOW) {
				this.sendRequestPermission()
			}
		}
	},

	sendRequestPermission() {
		this.messaging.requestPermission()
			.then(() => {
				log('info', 'main', 'push notifications', 'permission granted')()
				this.messaging.useServiceWorker(this.swRegistration)
				this.getRegistrationToken()
			})
			.catch(error => {
				console.error('Unable to get permission to notify', error)
			})
			.finally(() => this.context.$root.$emit('notification-update-status', {}))
	},

	// Get push notification token
	getRegistrationToken () {
		log('info', 'main', 'push notifications', 'get registration token')()

		if (!('PushManager' in window && 'Notification' in window)) {
			log('warn', 'main', 'push notifications', 'not supported in this browser')()
			return
		}

		this.messaging.getToken()
			.then(token => {
				if (token) {
					log('info', 'main', 'push notifications', 'token:', token)()
					this.pushToken = token

					this.callback()

					this.messaging.onTokenRefresh(function () {
						alert('token refreshed !')
					})
				} else {
					console.log('No Instance ID token available. Request permission to generate one.')
				}
			})
			.catch(error => {
				console.error('An error occurred while retrieving token. ', error)
			})
	},

	// Store client token and setup message listener
	setupClient (context) {
		// Update push token in app store
		context.$store.dispatch('setPushToken', { context, token: this.pushToken })

		// Setup messages event listener
		navigator.serviceWorker.addEventListener('message', event => {
			// Check if message is alert notification
			if (event.data.hasOwnProperty('alert_id')) {
				log('info', 'main', 'service worker alert', event.data)()
				// Display in app notification
				context.$root.$emit('add-floating-box', { title: 'Alert', message: 'New alert!' })
				// Update alerts in app store
				// context.$store.dispatch('getAccountAlerts', { context, user_uid: event.data.user })
				var user = context.$store.getters.CURRENT_USER
				context.$store.dispatch('GET_PATIENTS_BY_USER', { refThis: context, user })
			} else {
				log('info', 'main', 'service worker message', event.data)()
			}

			const { action } = event.data
			const port = event.ports[0]
			if(action === 'getAuthTokenHeader') {
				console.debug('Token request from sw')
				// return authHeader, will be accessible in sw via event.data.authHeader
				port.postMessage({
				  authHeader: localStorage.getItem('token')
				})
			}
		})
		log('info', 'main', 'service worker', 'setup client done')()
	}
}



// WEBPACK FOOTER //
// ./src/sw/index.js